import React, { useState } from 'react';
import httpClient from '../../../services/httpClient'
import { Address } from "../../form"

const MatchWithCaution = ({ lawFirm, accountNumber, sortCode, match, pdfLink, userName, loggedInLawFirmName }) => {

    const [error, setError] = useState('');

    const statusContainerOutput = {
        backgroundColor: '#f4f4f4',
        borderRadius: 5.7,
    }

    const statusContainer = {
        borderRadius: 5.7,
        backgroundColor: '#f4f4f4',
        borderBottomColor: '#ff5f00',
        borderBottomStyle: 'solid',
        borderBottomWidth: 10
    }

    const statusContainerMainHeader = {
        fontSize: 42,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const statusContainerSubHeader = {
        fontSize: 18,
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'black'
    }

    const accountDetailsText = {
        fontSize: '16px',
        fontWeight: '300',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#000'
    }

    const handleDownloadPdfCopy = async (event) => {
        let response = null;
        try {
            httpClient.defaults.headers.common['Username'] = userName;
            httpClient.defaults.headers.common["Account-Number"] = accountNumber;
            httpClient.defaults.headers.common["Sort-Code"] = sortCode;
            httpClient.defaults.headers.common["Users-Law-Firm"] = loggedInLawFirmName;
            httpClient.defaults.headers.common["Users-Law-Firm-Reference"] = "";
            response = await httpClient.get(pdfLink, { responseType: 'blob' });
            const url = window.URL.createObjectURL(response, { type: 'application/pdf' });
            let a = document.createElement('a');
            a.href = url;
            a.download = "outcome.pdf";
            a.click();
            a.remove();
        } catch (e) {
            if (e.response.status === 404) {
                //404 status code means transient Id from the original search has expired. We want to display a specific message for this error scenario
                setError('Your Session has timed out. You will need to start a new search');
            }
            else {
                setError('Unfortunately we were unable to retrieve your PDF Summary at this time. If you require further assistance, please contact the team on 0343 221 0610');
                if (!e.response.data) {
                    if (e.response.data.errors?.length >= 1) {
                        setError(e.response.data.errors[0]);
                    }
                }
            }
        }
    }

    return (
        <div data-testid="match-caution-component">
            {match === 'Match with Cautions' ? (
                <div data-testid="match-caution-component-cautioned">
                    <div style={statusContainer} className="mt-2 p-5">
                        <div className="row">
                            <div className="col-1">
                                <img height="75px" src="data:image/png;base64, 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" alt="Confirmly Matched Icon" />
                            </div>
                            <div className="col-9">
                                <span style={statusContainerMainHeader} className="ml-3" id="itsStatus">
                                    It's a match
                                </span>
                                <span id="withCautions">
                                    &nbsp;with cautions
                                </span>
                                <p style={statusContainerSubHeader} className="mt-1 ml-3" id="itsUnderReview">
                                    The law firm is known and has regulatory alerts.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div style={accountDetailsText} className="row mt-3 mb-3">
                        <div className="col-10 text-danger">
                            {error}
                        </div>
                    </div>
                    <div style={accountDetailsText} className="row">
                        <div className="col-10 fw_bold">
                            The account details you provided match the ones we hold for the firm but with cautions.
                        </div>
                        <div className="col-2">
                            <button className="fs-6 btn btn-dark" onClick={handleDownloadPdfCopy} id="pdfButton"> <i className="fa-solid fa-file-arrow-down"></i>&nbsp;&nbsp;&nbsp;DOWNLOAD PDF </button>
                        </div>
                    </div>
                    <div style={accountDetailsText} className="row mb-5">
                        <div className="col-12 fw_bold">
                            For a full summary download the pdf.
                        </div>
                    </div>
                    {
                        /* 
                            JAS-7677 - COMMENTED UNTIL: JAS-7601
                            <div style={accountDetailsText} className="row mt-4 mb-5">
                                <div className="col-12 fw_bold text-decoration-underline">
                                    Does this mean it's safe to send the money?
                                </div>
                            </div> 
                        */
                    }
                    <div style={statusContainerOutput} className="p-5">
                        <div className="row">
                            <div className="col-1">
                                <img src="data:image/png;base64, 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" alt="Confirmly Matched Icon" />
                            </div>
                            <div className="col-9 mt-4">
                                <span className="fs-2">YOU ASKED US TO CHECK THESE DETAILS</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Company name
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.companyName}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Address
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                <Address lawFirm={lawFirm} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Regulation Registration Number for LMS Main Office
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {lawFirm?.regulationRegistrationNumber ? (lawFirm?.regulationRegistrationNumber) : ('Not Supplied')}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Sort code
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {sortCode}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 fw-bold mt-2">
                                Account number
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11 mt-2">
                                {accountNumber}
                            </div>
                        </div>

                    </div>
                </div>
            ) : (null)}
        </div>
    );
}

export default MatchWithCaution;